import type { SVGProps } from "react";

export const NoProductIllustraction = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="313"
      height="235"
      fill="none"
      viewBox="0 0 313 235"
      {...props}
    >
      <path
        fill="#DEF2FF"
        d="M258 41l3.116 18.917c2.787 16.92 16.048 30.18 32.967 32.967L313 96l-18.917 3.116c-16.919 2.787-30.18 16.048-32.967 32.967L258 151l-3.116-18.917c-2.787-16.919-16.048-30.18-32.967-32.967L203 96l18.917-3.116c16.919-2.787 30.18-16.048 32.967-32.967L258 41zM220 0l.963 5.847a12.364 12.364 0 0010.19 10.19L237 17l-5.847.963a12.364 12.364 0 00-10.19 10.19L220 34l-.963-5.847a12.364 12.364 0 00-10.19-10.19L203 17l5.847-.963a12.364 12.364 0 0010.19-10.19L220 0zM17 62l.963 5.847a12.364 12.364 0 0010.19 10.19L34 79l-5.847.963a12.364 12.364 0 00-10.19 10.19L17 96l-.963-5.847a12.364 12.364 0 00-10.19-10.19L0 79l5.847-.963a12.364 12.364 0 0010.19-10.19L17 62zM62.5 145l.77 20.81c.47 12.731 10.662 22.942 23.363 23.407L108 190l-21.367.783c-12.701.465-22.893 10.676-23.364 23.407L62.5 235l-.77-20.81c-.47-12.731-10.662-22.942-23.363-23.407L17 190l21.367-.783c12.701-.465 22.893-10.676 23.364-23.407L62.5 145z"
      ></path>
      <g clipPath="url(#clip0_844_11930)">
        <path
          fill="#0648FF"
          d="M140.5 136.5L121 117l19.5-19.5a4.92 4.92 0 000-7 4.92 4.92 0 00-7 0l-22.95 22.95a4.98 4.98 0 000 7.05l22.95 23a4.92 4.92 0 007 0 4.92 4.92 0 000-7zm33 0L193 117l-19.5-19.5a4.92 4.92 0 010-7 4.92 4.92 0 017 0l22.95 22.95a4.98 4.98 0 010 7.05l-22.95 23a4.92 4.92 0 01-7 0 4.92 4.92 0 010-7z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_844_11930">
          <path
            fill="#fff"
            d="M0 0H120V120H0z"
            transform="translate(97 57)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
};
